import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { useEffectOnce } from 'react-use';
import exit from '~/assets/icons/exit.svg';
import { Text } from '~/components/ui/Text';
import { Apps } from '~/shared';
import myBusinessIcon from '../../assets/icons/apps/my_business.svg';
import {
	resetMyBusinessSlice,
	returnToLauncher,
	setMyBusinessActivePage,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppMyBusinessAbout } from '../AppMyBusinessAbout';
import { AppMyBusinessReports } from '../AppMyBusinessReports';
import { AppMyBusinessShop } from '../AppMyBusinessShop';
import { AppMyBusinessShopItemPage } from '../AppMyBusinessShopItemPage';
import {
	StyledAppTitleContainer,
	StyledContainer,
	StyledExitButton,
	StyledFilterButton,
	StyledItemPageContainer,
	StyledLayoutContainer,
	StyledLeftContainer,
	StyledMenuContainer,
	StyledRightContainer,
	StyledWrapper,
} from '../DefaultAppLayout';
import { LoadingScreen } from '../LoadingScreen';
import { getAppLoadingInfo } from '../TabletApp';
import {
	AppMyBusinessPages,
	appMyBusinessMenuItems,
} from './AppMyBusiness.model';

const AppMyBusiness = () => {
	const dispatch = useLayoutDispatch();
	const activePage = useLayoutSelector(
		(state) => state.myBusiness.activeMyBusinessPage,
	);
	const shopItemPageVisible = useLayoutSelector(
		(state) => state.myBusiness.shopItemPageVisible,
	);
	const loadingInfo = getAppLoadingInfo(Apps.MyBusiness);
	const [loading, setLoading] = useState(true);

	useEffectOnce(() => {
		setTimeout(() => {
			setLoading(false);
		}, 1000);

		return () => {
			dispatch(resetMyBusinessSlice());
		};
	});

	return (
		<StyledWrapper>
			<SwitchTransition>
				<CSSTransition
					timeout={300}
					key={loading ? 0 : 1}
					classNames={'loading'}
					addEndListener={(node, done) =>
						node.addEventListener('transitionend', done, false)
					}
				>
					{loading ? (
						<LoadingScreen
							icon={loadingInfo.loadingIcon}
							text={loadingInfo.loadingMessage}
							color={loadingInfo.color}
							name={loadingInfo.name}
						/>
					) : (
						<StyledContainer>
							<StyledLayoutContainer>
								<StyledLeftContainer>
									<StyledAppTitleContainer>
										<img src={myBusinessIcon} />
										<div>
											<Text className={'title'}>Мой бизнес</Text>
											<Text className={'text'}>Управляй бизнесом проще!</Text>
										</div>
									</StyledAppTitleContainer>
									<StyledMenuContainer style={{ marginTop: 25, flex: 1 }}>
										{Object.values(AppMyBusinessPages).map((item) => (
											<StyledFilterButton
												$active={activePage === item}
												key={item}
												onClick={() => dispatch(setMyBusinessActivePage(item))}
												$color={'#3491E9'}
											>
												<img src={appMyBusinessMenuItems[item].icon} />
												<Text>{appMyBusinessMenuItems[item].name}</Text>
											</StyledFilterButton>
										))}
									</StyledMenuContainer>
									<StyledMenuContainer>
										<StyledExitButton
											onClick={() => dispatch(returnToLauncher())}
										>
											<img src={exit} />
											<Text>Выйти из приложения</Text>
										</StyledExitButton>
									</StyledMenuContainer>
								</StyledLeftContainer>
								<StyledRightContainer
									style={{ minHeight: 0, overflow: 'hidden' }}
								>
									{activePage === AppMyBusinessPages.Main && (
										<AppMyBusinessAbout />
									)}
									{activePage === AppMyBusinessPages.Shop && (
										<AppMyBusinessShop />
									)}
									{activePage === AppMyBusinessPages.Reports && (
										<AppMyBusinessReports />
									)}
									{activePage === AppMyBusinessPages.Shop &&
										shopItemPageVisible && (
											<StyledItemPageContainer>
												<AppMyBusinessShopItemPage />
											</StyledItemPageContainer>
										)}
								</StyledRightContainer>
							</StyledLayoutContainer>
						</StyledContainer>
					)}
				</CSSTransition>
			</SwitchTransition>
		</StyledWrapper>
	);
};

export { AppMyBusiness };
